<template>
  <div class="klickbox-step-text-edit">
    <textarea
      v-if="step.text_size === 'long'"
      @change="stepUpdateTextPlaceholder({ placeholderText: $event.target.value, id: step.id })"
      class="klickbox-step-input-edit"
      v-model="placeholderText"
      rows="5"></textarea>
    <input
      v-else
      @change="stepUpdateTextPlaceholder({ placeholderText: $event.target.value, id: step.id })"
      :value="placeholderText"
      type="text"
      class="klickbox-step-input-edit">
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: [
    'step',
  ],
  computed: mapGetters({
    placeholderText: 'stepTextPlaceholder',
  }),
  methods: mapActions([
    'stepUpdateTextPlaceholder',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Text.vue?34e38ec8
 **/